<template>

	<v-content>
		<v-container fluid>
			<div class="wellcome">
				<div class="left">
					<img src="@/assets/robot.png">
				</div>
				<div class="right">
					<div class="bigtext">
						Merhaba, <b>{{getSignedUser.firstname}}</b>
					</div>
					<hr>
					<div class="text">
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe eveniet quod
						eligendi blanditiis placeat doloremque fugit, iste magni numquam ratione fugiat
						sunt nesciunt vitae maiores minima ducimus nemo ipsa facilis!
					</div>
					<div class="button">
						<v-btn color="success">Success</v-btn>
						<v-btn color="error">Error</v-btn>
						<v-btn color="warning">Warning</v-btn>
						<v-btn color="info">Info</v-btn>
					</div>
				</div>
			</div>
			<ServerStatus />
		</v-container>
 
	</v-content>


</template>

<script>
	import ChartProgress from "@/components/tools/ChartProgress";
	import ServerStatus from "@/includes/Home/ServerStatus";

	export default {
		name: "ServerCron",
		components: {
			ChartProgress,
			ServerStatus,
		},
		data: () => ({
			loadavg: 0,
			loadavgVal: 0,
			loadcolor: "primary",
			items: [{
					active: true,
					title: 'Jason Oner',
					avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg'
				},
				{
					active: true,
					title: 'Ranee Carlson',
					avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg'
				},
				{
					title: 'Cindy Baker',
					avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg'
				},
				{
					title: 'Ali Connors',
					avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg'
				}
			],
			items2: [{
				title: 'Travis Howard',
				avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg'
			}]
		}),
		mounted() {
			var self = this;
			if (!window.lod) {
				setInterval(function () {
					self.loadavg = Math.floor(Math.random() * 200);
					self.loadcolor = "success";
					if (self.loadavg > 40) {
						self.loadcolor = "orange"
					}
					if (self.loadavg > 100) {
						self.loadcolor = "error"
					}
					self.loadavgVal = Math.round(self.loadavg * 100) / 100
				}, 1000)
				window.lod = true;
			}
		},
		computed : { 
			getSignedUser(){
				return this.$store.state.signedUser
			}
		}
	}
</script>


<style lang="less" scoped>
	.wellcome {
		display: flex;
		margin-bottom:20px;

		.left {
			width: 200px;

			img {
				width: 100%;
			}
		}

		.right {
			flex: 1;

			// margin-left: 200px;
			.bigtext {
				font-size: 36px;
				color: #40657c;
			}

			.text {
				font-weight: 500;
				min-height: 60px;
			}

			hr {
				color: #eee;
				max-width: 200px;
				margin: 15px 0px 18px 0px;
				opacity: .6;
			}

			.button {
				margin-left: -8px;
			}
		}
	}
</style>